import { render, staticRenderFns } from "./ProcedureDocument.vue?vue&type=template&id=3e3c355f&"
import script from "./ProcedureDocument.vue?vue&type=script&lang=js&"
export * from "./ProcedureDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports